<template>
  <span>
    <v-avatar :tile="tile" :size="size" v-show="!isShowCanvas">
      <img
        ref="img"
        :src="currentSrc"
        :alt="alt"
        :class="classes"
        :width="width"
        :height="height"
        v-on:error="altSrc"
      />
    </v-avatar>
    <canvas
      ref="canvas"
      v-show="isShowCanvas"
      style="border-radius: 50%;"
    ></canvas>
  </span>
</template>
<script>
export default {
  name: "vc-share-avatar-image",
  props: {
    src: { type: String, default: "" },
    alt: { type: String, default: "" },
    classes: { type: String, default: "" },
    size: { type: Number, default: 0 },
    tile: { type: Boolean, default: false }
  },
  data: function() {
    return {
      isShowCanvas: false,
      timerId: null,
      defaultUserPictureUrl: require("./assets/ico_noimage.gif"),
      width: this.size + "px",
      height: this.size + "px",
      currentSrc: require("./assets/ico_noimage.gif")
    };
  },
  mounted() {
    this.currentSrc = this.src;
    if (
      document.documentMode &&
      window.devicePixelRatio &&
      window.devicePixelRatio == 1.0
    ) {
      this.image2canvasProcess();
      window.addEventListener("scroll", this.image2canvasOnScroll);
    }
  },
  watch: {
    src: function() {
      this.currentSrc = this.src;
      if (
        document.documentMode &&
        window.devicePixelRatio &&
        window.devicePixelRatio == 1.0
      ) {
        this.image2canvasProcess();
      }
    }
  },
  methods: {
    image2canvasProcess() {
      const img = this.$refs.img;
      if (img.style.display == "none") {
        return;
      }
      // 要素が画面内になければ、処理をしない
      if (!this.isInViewport(img)) {
        return;
      }
      const canvasElement = this.$refs.canvas;
      canvasElement.style.width = this.width;
      canvasElement.style.height = this.height;
      try {
        const srcimg = new Image();
        srcimg.src = this.currentSrc;
        srcimg.onload = () => {
          const tmp_cvs = document.createElement("canvas");
          tmp_cvs.width = img.width;
          tmp_cvs.height = img.height;
          let tw = srcimg.width;
          let th = srcimg.height;
          let current_canvas = srcimg;
          current_canvas.width = tw;
          current_canvas.height = th;
          tw /= 2;
          th /= 2;
          while (tw >= tmp_cvs.width && th >= tmp_cvs.height) {
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            canvas.width = tw;
            canvas.height = th;
            context.drawImage(
              current_canvas,
              0,
              0,
              current_canvas.width,
              current_canvas.height,
              0,
              0,
              tw,
              th
            );
            current_canvas = canvas;
            tw /= 2;
            th /= 2;
          }
          const target_ctx = canvasElement.getContext("2d");
          target_ctx.drawImage(
            current_canvas,
            0,
            0,
            current_canvas.width,
            current_canvas.height,
            0,
            0,
            canvasElement.width,
            canvasElement.height
          );
          this.isShowCanvas = true;
          window.removeEventListener("scroll", this.image2canvasOnScroll);
        };
        srcimg.onerror = () => {
          this.isShowCanvas = false;
        };
      } catch (e) {
        this.isShowCanvas = false;
      }
    },
    image2canvasOnScroll() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      this.timerId = setTimeout(this.image2canvasProcess, 2000);
    },
    isInViewport(element) {
      const threshold = 100;
      let imgRect = element.getBoundingClientRect();
      return (
        !(window.height + window.scrollY <= imgRect.top - threshold) &&
        !(window.scrollY >= imgRect.top + threshold + imgRect.height)
      );
    },
    altSrc: function() {
      this.currentSrc = this.defaultUserPictureUrl;
    }
  }
};
</script>
